import { useEffect, useState } from "react";

import { debounce } from "@/src/components/listing-map/map/helpers";

const useResponsive = () => {
  const getScreenSizes = () => {
    if (typeof window === "undefined") {
      return {
        isMobile: false,
        isTablet: false,
        isDesktop: false,
      };
    }

    const width = window.innerWidth;
    return {
      isMobile: width <= 640,
      isTablet: width >= 641 && width <= 1024,
      isDesktop: width >= 1025,
    };
  };

  const [screen, setScreen] = useState(getScreenSizes);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const debouncedUpdate = debounce(() => setScreen(getScreenSizes()), 100);
    window.addEventListener("resize", debouncedUpdate);
    return () => window.removeEventListener("resize", debouncedUpdate);
  }, []);

  return screen;
};

export default useResponsive;
